export default "__VITE_ASSET__fr7MB_yF__"